'use client';
import { useState } from 'react';
import { ServiceInsightWrapperProps } from './types';
import { ServiceInsightCard } from './service-insight-card';
import { ServiceInsightHeading } from './service-insight-card/service-insight-heading';
import { ServiceInsightViewAllModal } from './service-insight-card/service-insight-viewall-modal';

export const ServiceInsightWrapper = ({
  serviceInsights
}: ServiceInsightWrapperProps) => {
  const [viewAllmodal, setViewAllmodal] = useState(false);
  const handleViewAllModal = () => {
    setViewAllmodal(true);
  };

  return (
    <>
      <ServiceInsightHeading
        isNewCount={false} //later from new status task will update
        handleViewAllModal={handleViewAllModal}
        isViewAllBtnEnable={serviceInsights.length > 2}
      />
      <ServiceInsightCard
        serviceInsights={serviceInsights}
        data-testid="service-insights"
      />
      <ServiceInsightViewAllModal
        serviceInsights={serviceInsights}
        isOpen={viewAllmodal}
        onClose={() => setViewAllmodal(false)}
        isNewCount={false}
      />
    </>
  );
};
